import { Card, CardBody } from '@vnetwork/ui/primitives';
import { Section } from '@vnetwork/ui/layout';
import styles from './JobDetailMediaCards.module.css';

interface MediaField {
  label: string;
  value?: string | null;
}

interface MediaCardProps {
  title: string;
  fields: MediaField[];
}

function MediaCard({ title, fields }: MediaCardProps) {
  const hasData = fields.some((f) => f.value != null && f.value !== '');
  return (
    <Card flat>
      <CardBody>
        <p className={styles.cardTitle}>{title}</p>
        {hasData ? (
          <dl className={styles.fieldList}>
            {fields.map((f) => (
              <div key={f.label} className={styles.fieldRow}>
                <dt className={styles.fieldLabel}>{f.label}</dt>
                <dd className={styles.fieldValue}>{f.value || '—'}</dd>
              </div>
            ))}
          </dl>
        ) : (
          <p className={styles.empty}>No {title.toLowerCase()} data.</p>
        )}
      </CardBody>
    </Card>
  );
}

interface MediaSpecs {
  video: {
    codec?: string | null;
    resolution?: string | null;
    fps?: string | null;
    bitrate?: string | null;
    aspectRatio?: string | null;
  };
  audio: {
    codec?: string | null;
    sampleRate?: string | null;
    bitrate?: string | null;
    channels?: string | null;
  };
  subtitleCount: number;
}

interface Props {
  media: MediaSpecs;
}

export function JobDetailMediaCards({ media }: Props) {
  return (
    <Section title="Media Specifications" description="Detected video, audio and subtitle properties." style={{ marginBottom: 0 }}>
      <div className={styles.grid}>
        <MediaCard
          title="Video"
          fields={[
            { label: 'Codec', value: media.video.codec },
            { label: 'Resolution', value: media.video.resolution },
            { label: 'FPS', value: media.video.fps },
            { label: 'Bitrate', value: media.video.bitrate },
            { label: 'Aspect Ratio', value: media.video.aspectRatio },
          ]}
        />
        <MediaCard
          title="Audio"
          fields={[
            { label: 'Codec', value: media.audio.codec },
            { label: 'Sample Rate', value: media.audio.sampleRate },
            { label: 'Bitrate', value: media.audio.bitrate },
            { label: 'Channels', value: media.audio.channels },
          ]}
        />
        <MediaCard
          title="Subtitle"
          fields={[
            { label: 'Status', value: media.subtitleCount ? `${media.subtitleCount} track(s) available` : 'No subtitle' },
          ]}
        />
      </div>
    </Section>
  );
}
